import React, { useState, useEffect, useContext } from "react";
import Navbar from "../../components/Navbar/Navbar";
import { myWinnings } from "../../Utils/apis";
import { notification } from "antd";
import { useHistory, Redirect } from "react-router-dom";
import { PlayContext } from "../../App";
import axios from "axios";
import Moment from 'react-moment';

const MyWinnings = () => {
  const { open, toggleOpen } = useContext(PlayContext);
  const [winnings, setWinnings] = useState([]);
  const history = useHistory();

  useEffect(() => {
    getMyWinnings();
  }, []);

  const getMyWinnings = () => {
    axios({
      method: "post",
      url: myWinnings,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        msisdn: localStorage.getItem("msisdn"),
      },
    })
      .then((res) => {
        console.log(res.data);
        console.log(res.data.winnings);
        setWinnings(res.data.winnings)
      })
      .catch((error) => {
        console.log({ error });
      });
  };

  if (
    localStorage.getItem("authed") === "notAuthenticated" ||
    !localStorage.getItem("authed")
  ) {
    return <Redirect to="/" />;
  }

  return (
    <>
      <Navbar />
      <div className="container pt-5">
        <div className="row">
          <div className="col-sm-12 col-md-8  ">
            <h2 className="header-text text-center pt-1"> SPIN TO WIN </h2>
            <h4 className=" text-center text-white">
              <u>My Winnings</u>
            </h4>

            <h6 className="text-white  mt-5">
              Here's the history of prizes that youve won in recent times
            </h6>
            <table class="table table-light table-striped table-bordered">
              <thead class="thead-dark">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Msisdn</th>
                  <th scope="col">Prize</th>
                  <th scope="col">Category</th>
                  <th scope="col">Reedemed</th>
                  <th scope="col">Created Date</th>
                </tr>
              </thead>
              <tbody>
                {winnings.map((winning, index) => {
                    JSON.stringify(winning)
                  return <tr>
                      <th scope="row">{index}</th>
                      <td>{localStorage.getItem("msisdn")}</td>
                      <td>{winning.prize.item}</td>
                      <td>{winning.prize.category.name}</td>
                      <td>{winning.reedem_status ? "Yes" : "No"}</td>
                      <td><Moment>{winning.created_at}</Moment></td>
                    </tr>
                  
                })}
              </tbody>
            </table>
          </div>

          {/* <div className="order-sm-12 col-md-5 mobileHide pull-right "></div> */}
          <div className=" col-md-4  pull-right ">
            <li class="list-group-item my-2 text-white bg-primary text-capitalize font-weight-bold">
              Other Recent Winners
            </li>
            <ul
              class="list-group"
              style={{ height: "500px", overflowY: "scroll" }}
            >
              <li class="list-group-item my-2 d-flex justify-content-between">
                <div className="">User123!h just won airtime</div>
                <div className=""> #500</div>
              </li>
              <li class="list-group-item my-2 d-flex justify-content-between">
                <div className="">User232h just won data</div>
                <div className=""> 500mb</div>
              </li>
              <li class="list-group-item my-2 d-flex justify-content-between">
                <div className="">User123!h just won airtime</div>
                <div className=""> #50</div>
              </li>
              <li class="list-group-item my-2 d-flex justify-content-between">
                <div className="">User795 just won airtime</div>
                <div className=""> #100</div>
              </li>
              <li class="list-group-item my-2 d-flex justify-content-between">
                <div className="">User765 just won nothing</div>
                <div className=""> #0</div>
              </li>
              <li class="list-group-item my-2 d-flex justify-content-between">
                <div className="">User894 just won airtime</div>
                <div className=""> #50</div>
              </li>
              <li class="list-group-item my-2 d-flex justify-content-between">
                <div className="">User856 just won nothing</div>
                <div className=""> #0</div>
              </li>
              <li class="list-group-item my-2 d-flex justify-content-between">
                <div className="">User123!h just won airtime</div>
                <div className=""> #500</div>
              </li>
              <li class="list-group-item my-2 d-flex justify-content-between">
                <div className="">User101 just won airtime</div>
                <div className=""> #500</div>
              </li>
              
              <li class="list-group-item my-2 d-flex justify-content-between">
                <div className="">User606 just won airtime</div>
                <div className=""> #400</div>
              </li>
              <li class="list-group-item my-2 d-flex justify-content-between">
                <div className="">User767 just won data</div>
                <div className=""> 50 mb</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyWinnings;
